import Naluri from '~/common/api/naluri';
import qs from 'qs';
import { Map, fromJS } from 'immutable';
import {
  FEEDS_GET_PUBLIC_FEEDS_BEGIN,
  FEEDS_GET_PUBLIC_FEEDS_SUCCESS,
  FEEDS_GET_PUBLIC_FEEDS_FAILURE,
  FEEDS_GET_PUBLIC_FEEDS_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getPublicFeeds(params) {
  return dispatch => {
    // optionally you can have getState as the second argument
    dispatch({
      type: FEEDS_GET_PUBLIC_FEEDS_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      params = qs.stringify(params);

      const doRequest = Naluri.get(`/api/expert/feed_history?${params}`);

      doRequest.then(
        res => {
          dispatch({
            type: FEEDS_GET_PUBLIC_FEEDS_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: FEEDS_GET_PUBLIC_FEEDS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetPublicFeedsError() {
  return {
    type: FEEDS_GET_PUBLIC_FEEDS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FEEDS_GET_PUBLIC_FEEDS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getPublicFeedsPending: true,
        getPublicFeedsError: null,
      };

    case FEEDS_GET_PUBLIC_FEEDS_SUCCESS:
      // The request is success
      return {
        ...state,
        listing: Map(fromJS(action.data)),
        getPublicFeedsPending: false,
        getPublicFeedsError: null,
      };

    case FEEDS_GET_PUBLIC_FEEDS_FAILURE:
      // The request is failed
      return {
        ...state,
        getPublicFeedsPending: false,
        getPublicFeedsError: action.data.error,
      };

    case FEEDS_GET_PUBLIC_FEEDS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getPublicFeedsError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/feeds/redux/getPublicFeeds.js